import { get, postJSON, del, post } from '../utils/axios'

// 获取jsSDK签名
export interface GetWxSdkTokenParams {
    url: string // 页面地址
}
export const getWxSdkToken = (appid, options: GetWxSdkTokenParams) => get(`/yme-wxmp/wx/jsapi/${appid}/getJsapiTicket`, {
    ...options
}, { }, false)

// 获取用户基本信息
export interface GetUserInfoParams {
    code: string // 授权返回的code
}
export const getUserInfo = (appid, options: GetUserInfoParams) => get(`/yme-wxmp/wx/user/${appid}/getUserInfo`, {
    ...options
}, {}, false)

// 公众号查询车辆信息
export interface GetUserInfoByCarNoParams {
    carNo: string // 车牌号
    orgPk: string // 门店pk
}
export const getUserInfoByCarNo = (options: GetUserInfoByCarNoParams) => get('car/getCarNoInfo', {
    ...options
})

// 公众号查询客户车辆信息
export interface GetUserInfoByPkParams {
    orgPk: string // 门店pk
    userPk: string // 客户pk
}
export const getUserInfoByPk = (options: GetUserInfoByPkParams) => post('user/selectWxUserAndCarInfoByUserPk', {
    ...options
})

// 更新客户openid和关注状态
export interface UpdateUserOpenIdParams {
    carNo: string
    openId: string
    orgPk: string
    subscribe: '1' | '0',
    userPk?: string
}
export const updateUserOpenId = (options: UpdateUserOpenIdParams) => post('user/updateUserOpenId', {
    ...options
})

// 手机号验证-更新客户openid和关注状态
export interface UpdateUserOpenIdByVerificationCodeOptions {
    carNo: string // 车牌号
    name: string // 姓名
    openId: string // 当前授权的公众号openId
    orgPk: string // 门店pk
    phone: string // 手机号
    verificationCode: string // 验证码
}
export const updateUserOpenIdByVerificationCode = (options: UpdateUserOpenIdByVerificationCodeOptions) => post('user/updateUserOpenIdByVerificationCode', {
    ...options
})

// 解除绑定客户公众号关注状态
export interface UpdateUserBindWxStatusParams {
    openId: string // openid
    orgPk: string // 门店pk
    userPk: string // 客户pk
}
export const updateUserBindWxStatus = (options: UpdateUserBindWxStatusParams) => post('user/unBindUserWxRelation', {
    ...options
})

// 发送验证码
export const sendPhoneCaptch = (phone: string | number) => post('common/sendPhoneCode', { phone })

// 校验验证码
export interface CaptchValidationParams {
    phone: string | number // 手机号码
    verificationCode: string // 验证码
}
export const captchValidation = (options: CaptchValidationParams) => post('common/checkVerification', { ...options })